/**
 * created by yxy
 *
 */

/**
 * 分类组件
 */
import React, {Component} from 'react';
import DeliveryResources from "../../components/deliveryResources/DeliveryResources";
import {Button, Icon, Divider, Steps, message, Modal} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import PropTypes from "prop-types";
import UpLoad from "./Upload";
import {ATTCHMENT_TYPE, AUDIO_TYPE, FILE_TYPE, PIC_TYPE, VIDEO_TYPE} from "../../../constants";
import HoldAll from "../../../view/components/holdAll/HoldAll";
import {getSubffix,ArrayDuplication} from "../../../utils";
import {getFileImage} from "../../../components/upload/UploadWall";
import *as Actions from "../../../actions/allResources"
import {filesToDirectory, getStorageDirectory, collection} from "../../../actions/allResources";
import { checkFileStatus } from "../../../actions/upload";

const {Step} = Steps;
let allFile =[];
export default class SetUp extends Component {
    // 默认属性
    static defaultProps = {
        listArray: ['选择资源', '公开设置', '分享设置', '上传完成']
    };
    // 静态类型分析
    static propTypes = {
        listArray: PropTypes.array.isRequired,//数组
    };

    constructor(props) {
        super(props);
        this.state = {
            current: 0,
            fileList: [],
            publishFileListClassify: [],//公开的时候的内容区域文件
            shareFileListClassify: [],//分享的时候的内容区域文件
            fileListClassify: [],//内容区域文件,做渲染的时候用
            publish: true,
            tableData: ["用户分享", "部门分享"],
            treeData: [],
            targetKeys: [],
            user: [],
            department: [],
            downloadUser: [],
            downloadDepartment: [],
            resourceType: '',
            collection: false,
            resourceIds: [],
            stepShare:true,
            btnDisabled:true,
            publicText:'全选',
            shareText:'全选'
        };

    }

    // show(){
    //     this.state.warehousing= true
    // }

    componentDidMount() {

    }

    //关闭工具箱的弹框
    handleCancel = e => {
        this.setState({warehousing: false});
    };

    render() {
        return (
            <div>
                <Steps current={this.state.current} labelPlacement={'vertical'}>
                    <Step description="选择资源"/>
                    <Step description="公开设置"/>
                    {
                        this.state.stepShare?  <Step description="分享设置"/>:null
                    }
                    {/* <Step description="下载设置"/>*/}
                    <Step description="设置完成"/>
                </Steps>
                <div style={{marginTop: "15px"}}>
                    <Scrollbars style={{height: '550px'}}>
                        {
                            this.state.current === 0 ?
                                <div style={{paddingTop: 20}}><UpLoad type={this.props.resourceType}
                                                                      fileList={this.state.fileList}
                                                                      imgHandleChange={this.imgHandleChange}
                                                                      fileError={(md5)=>{
                                                                          this.state.fileList.forEach(item=>{
                                                                              if(item.originFileObj){
                                                                                  if(md5===item.originFileObj.md5){
                                                                                      item.status='error';
                                                                                      this.setState({})
                                                                                  }

                                                                              }
                                                                          })

                                                                      }}
                                                                      updateFileList={(newFileList)=>this.setState(newFileList)}
                                />
                                </div> : null
                        }
                        {
                            this.state.current === 1 || this.state.current === 2 ? <div style={{margin: '0 30px'}}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    color: '#0050B3',
                                    marginTop: 40
                                }}>
                                    {
                                        this.state.current ===1?<div style={{cursor: 'pointer'}} onClick={()=>{this.allCheckedPublic(this.state.current)}}>{this.state.publicText}</div>:<div style={{cursor: 'pointer'}} onClick={()=>{this.allCheckedShare(this.state.shareText)}}>{this.state.shareText}</div>
                                    }

                                    {
                                        (() => {
                                            let btnName = "不公开";
                                            this.state.fileListClassify && this.state.fileListClassify.map(classify => {
                                                classify.list.map(file => {
                                                    //只要有一个文件状态是不公开，那么这个按钮就应该是公开。
                                                    if (!file.publish) {
                                                        btnName = "公开";
                                                    }
                                                })
                                            });
                                            return this.state.current === 1 ? <Button
                                                onClick={() => this.openAll(btnName === "公开")}>{btnName}</Button> : null
                                        })()
                                    }
                                    {
                                        this.state.current === 2 ?
                                            <div><Button onClick={() => this.share()}>分享设置</Button></div> : null
                                    }
                                </div>
                                <div>
                                    {
                                        (() => {
                                            let fileListClassify = this.state.publishFileListClassify;

                                            if (this.state.current === 2) {
                                                {
                                                    fileListClassify.forEach((item,index)=>{
                                                        // item.list.forEach((items,i)=>{
                                                        //     if(items.publish === true){
                                                        //          item.list.splice(i,1)
                                                        //     }
                                                        // });
                                                        // if(item.list.length === 0){
                                                        //     fileListClassify.splice(index,1)
                                                        // }
                                                    })
                                                }
                                                fileListClassify = this.state.shareFileListClassify;
                                            }
                                            return (
                                                fileListClassify.map((item, index) => {

                                                    return (
                                                        <div key={index}>
                                                            {
                                                                item.list.length? <Divider orientation="left">{item.name}</Divider>:null
                                                            }

                                                            <div style={{display: 'flex'}}>
                                                                <div style={{width: '100%'}}>{
                                                                    item.list.map((file, index) => {
                                                                        return <DeliveryResources
                                                                            showPublishBtn={this.state.current === 1}
                                                                            ext={file.ext} name={file.name}
                                                                            publish={file.publish} img={file.preview}
                                                                            type={file.type} key={index}
                                                                            checked={this.state.current === 2 ? file.shareChecked : file.publishChecked}
                                                                            imgOnclick={() => this.onChangeChecked(file, this.state.current === 2 ? "shareChecked" : "publishChecked")}
                                                                            singleOpen={() => this.singleOpen(file)}
                                                                            onChangeChecked={(e) => this.onChangeChecked(file, this.state.current === 2 ? "shareChecked" : "publishChecked")}/>;
                                                                    })
                                                                }
                                                                    <div style={{clear: 'both'}}/>
                                                                    <HoldAll
                                                                        onSaveCallback={(depr, user) => {
                                                                            this.state.department = depr;
                                                                            this.state.user = user;
                                                                            this.setState({})
                                                                        }}
                                                                        callbackData={(data) => this.department(data)}
                                                                        callbackUserData={(data) => {
                                                                            this.user(data)
                                                                        }}
                                                                        showProcess={false} showTabs={true}
                                                                        ref={(HoldAll) => this.holdAll = HoldAll}/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            )
                                        })()
                                    }
                                </div>
                            </div> : null
                        }
                        {
                            this.state.current === 3 ? <div style={{textAlign: 'center'}}>
                                <div><Icon type="check-circle"
                                           style={{fontSize: '80px', color: '#0050B3', marginTop: 145}}/></div>
                                <div style={{
                                    fontSize: '24px',
                                    color: '#666666',
                                    textAlign: 'center',
                                    lineHeight: '24px',
                                    marginTop: 40
                                }}>上传成功
                                </div>
                                <div style={{margin: '100px 0'}}><Button type="primary"
                                                                         onClick={this.complete}>完成</Button></div>
                            </div> : null
                        }
                    </Scrollbars>
                </div>
                <div style={{marginTop: "15px"}}>
                    {
                        this.state.current === 0 ? <div style={{textAlign: 'center'}}><Button type="primary" disabled={this.state.btnDisabled}
                                                                                              onClick={this.oneNextStep}>下一步</Button>
                        </div> : null
                    }
                    {
                        this.state.current === 1 || this.state.current === 2 ? <div style={{textAlign: 'center'}}>
                            <Button type="primary" onClick={this.goBack} style={{marginRight: 20}}>上一步</Button>
                            <Button type="primary"  onClick={this.stepNext}>下一步</Button>
                            {/*<Button type="primary" onClick={this.noDistribution}>暂不分配</Button>*/}

                        </div> : null
                    }
                </div>
                <Modal
                    visible={this.state.collection}
                    title="提示"
                    centered
                    onOk={() => this.saveCollection()}
                    onCancel={() =>
                        this.setState({collection: false},
                        this.filesToDirectory()
                        )}>

                    <div>
                        其中有 1 个资源已在系统中存在，如需使用可进行收藏，是否收藏?
                    </div>
                </Modal>
            </div>
        );
    }

    // department(data) {
    //     if (this.state.current === 2) {
    //         this.state.department = data;
    //
    //     } else if (this.state.current === 3) {
    //         this.state.downloadDepartment = data;
    //     }
    //     this.setState({})
    // }
    //
    // user(data) {
    //     if (this.state.current === 2) {
    //         this.state.user = data
    //     } else if (this.state.current === 3) {
    //         this.state.downloadUser = data
    //     }
    //     this.setState({})
    // }

    //单选
    onChangeChecked(file, attr) {
        file[attr] = !file[attr];
        this.setState({})

    }
        //隐藏
    hiddleShare(){
        this.state.fileListClassify.forEach((item, index) => {
        item.list.forEach((file, index) => {
        if(file.publish=== true){
            this.state.stepShare = false;
        this.setState({})
        }else{
            this.state.stepShare = true;
            this.setState({})
        }
        })});}
        //分享的弹框
        share = () => {
        let shareCheckedCount = 0;
        this.state.shareFileListClassify.map(item => {
        item.list.map(file => {
            if (file.shareChecked) {
                shareCheckedCount++;
            }
        })
        });
        if (shareCheckedCount === 0) {
        message.warn("请至少选择一个所需要分享的文件");
        return;
        }
        this.holdAll.show();
        this.setState({showProcess: true})
        };
    //暂不分配
    noDistribution = () => {
        this.publicNext()
    };
    //选择全部
    allCheckedPublic(current){
        this.state.fileListClassify.forEach((item, index) => {
            if(this.state.publicText === '全选'){
                item.list.forEach((file, index) => {
                    file.checked = true;
                    file.publishChecked= true;
                });
                this.state.publicText = '取消全选'
            }else{
                item.list.forEach((file, index) => {
                    file.checked = false;
                    file.publishChecked= false;
                });
                this.state.publicText = '全选'
            }
        });
        this.setState({})
    }
    allCheckedShare (current) {
        this.state.fileListClassify.forEach((item, index) => {
            if(this.state.shareText === '全选'){
                item.list.forEach((file, index) => {
                    file.checked = true;
                    file.shareChecked= true;
                });
                this.state.shareText = '取消全选'
            }else{
                item.list.forEach((file, index) => {
                    file.checked = false;
                    file.shareChecked= false;
                });
                this.state.shareText = '全选'
            }
        });
        this.setState({})
    };
    //完成
    complete = () => {
        this.setState({current: 0});
        if (this.props.close) {
            this.props.close();
        }
    };
    //返回上一层
    goBack = () => {
        let current = this.state.current;
        let currentAdd = current - 1;
        this.setState({current: currentAdd});
        if(currentAdd === 0){
            this.setState({stepShare:true})
        }

    };
    //选中的项全部公开/不公开
    openAll = (status) => {

        let publishCheckedCount = 0;
        let numAll=0;
        let publishNUm=0;
        this.state.publishFileListClassify.forEach((item, index) => {
            numAll=numAll+item.list.length;
            item.list.forEach((file, index) => {
                if (file.publishChecked) {
                    publishCheckedCount++;
                    file.publish = status;
                }
                if( file.publish){
                    publishNUm++;
                }
            });
            if(numAll===publishNUm){
                this.state.stepShare = false
            }else{
                this.state.stepShare = true
            }
        });



        if (publishCheckedCount === 0) {
            message.warn("请至少选择一个所需要公开/不公开的文件");
            return;
        }
        this.setState({});
    };

    //单个的公开
    singleOpen(file) {
        file.publish = !file.publish;
        this.setState({})
        this.hiddleShare()
    };

    // 下一步
    stepNext = () => {
        this.publicNext();
    };

    publicNext() {
        let current = this.state.current;
        this.state.shareFileListClassify = [];
        this.state.fileListClassify.forEach((item, index) => {
            this.state.shareFileListClassify.push({
                ...item,
                list: item.list.filter((file, i) => {
                    return !file.publish; //如果没有公开才放进设置分享队列，公开则不需要再分享了
                })
            })
        });
        let currentAdd = current + 1;
        if(this.state.stepShare === true){
            if (currentAdd === 2) {
                this.setState({publish: false})
            }
            if (currentAdd === 3) {
                this.saveUpLoad()
            }
        }else{
            currentAdd =  3;
            this.saveUpLoad()
        }

        this.setState({current: currentAdd,});
    };


    saveUpLoad() {
        let array = [];
        let params = {
            "dataSource": 5
        };
        let md5s = [];
        this.state.fileList.forEach((item, index) => {

            if (item.response.exist === true) {
                this.state.collection = true
            }
            let newItem = {};
            if (item.publish) {
                newItem.publish = 1
            } else {
                newItem.publish = 0
            }
            if (item.shareChecked === true) {
                newItem.usr = this.state.user;
                newItem.dsr = this.state.department;
            } else {
                newItem.usr = [];
                newItem.dsr = [];
            }
            newItem.md5 = item.response.storageFile.md5;
            newItem.name = item.response.storageFile.name;
            newItem.ext = item.response.storageFile.suffix;
            newItem.path = item.response.url;
            newItem.size = item.response.storageFile.size || item.size;
            newItem.imageHeight = item.response.storageFile.height;
            newItem.imageWidth = item.response.storageFile.width;
            newItem.defaultWaterPath = item.response.storageFile.defaultWaterPath;
            if (this.props.resourceType === 2 || this.props.resourceType === 3) {
                newItem.allTime = item.response.storageFile.duration
            }
            md5s.push(item.response.storageFile.md5);
            array.push(newItem)
        });
        if (this.props.resourceType === 1) {
            let that = this;
            params.pictures = array;
            Actions.savePicture(params, function (data) {
                let dataArray = JSON.parse(data);
                let resource = [];
                dataArray.forEach((item, index) => {
                    resource.push(item.resourceId);
                    that.setState({resourceId: resource})
                });
            })
        } else if (this.props.resourceType === 3) {
            let that = this;
            params.videos = array;
            Actions.saveVideo(params, function (data) {
                let dataArray = JSON.parse(data);
                let resource = [];
                dataArray.forEach((item, index) => {
                    resource.push(item.resourceId);
                    that.setState({resourceId: resource})
                });

            })
        } else if (this.props.resourceType === 2) {
            let that = this;
            params.audios = array;

            Actions.saveAudio(params, function (data) {
                let dataArray = JSON.parse(data);
                let resource = [];
                dataArray.forEach((item, index) => {
                    resource.push(item.resourceId);
                    that.setState({resourceId: resource})
                });
            })
        } else if(this.props.resourceType === 4) {
            let that = this;
            params.otherFiles = array;
            Actions.saveOtherFile(params, function (data) {
                let dataArray = JSON.parse(data);
                let resource = [];
                dataArray.forEach((item, index) => {
                    resource.push(item.resourceId);
                    that.setState({resourceId: resource})
                });
            })
        }
        else if(this.props.resourceType === 0) {
            let that = this;
            let params ={};
            let pictures =[];
            let videos =[];
            let audios =[];
            let otherFiles =[];
            array.forEach((item=>{
                if (PIC_TYPE.indexOf(item.ext) !== -1) {
                    pictures.push(item);
                } else if (VIDEO_TYPE.indexOf(item.ext) !== -1) {
                    videos.push(item);
                } else if (AUDIO_TYPE.indexOf(item.ext) !== -1) {
                    audios.push(item);
                } else {
                    otherFiles.push(item);
                }

            }));
            params = {
                pictures:pictures,videos:videos,audios:audios,otherFiles:otherFiles, dataSource: 5
            };
            Actions.saveAll(params, function (data) {
                let dataArray = JSON.parse(data);
                let resource = [];
                dataArray.forEach((item, index) => {
                    resource.push(item.resourceId);
                    that.setState({resourceId: resource})
                });
            })

        }
        if (this.state.collection === false) {
            this.filesToDirectory()
        }
    }

    //收藏(第三步)
    filesToDirectory() {
        let md5s = [];
        this.state.fileList.forEach((item, index) => {
            md5s.push(item.response.storageFile.md5);
        });
        filesToDirectory(this.props.resourceId, md5s.join(","), data => {

        })
    }

    //收藏(第二步)
    getStorageDirectory() {
        getStorageDirectory(this.props.resourceId, data => {
            this.filesToDirectory()
        })
    }

    //收藏(第一步)
    saveCollection() {
        let resource = this.state.resourceId.toString();
        collection(resource, data => {
            this.getStorageDirectory()
        })
        this.setState({collection: false})
    }

    //选择文件
    imgHandleChange = ({file, fileList,event}) => {
        let video = [];
      this.state.btnDisabled =true;
     if(file.response&&file.response.success){

         message.info('上传完成');
         setTimeout(()=>{
             this.setState({btnDisabled:false})
         },100)

     }
        if (file.status === "done") {
            let video= "." + [...VIDEO_TYPE].join(",.");
            let newFileList = fileList.map((item,index) => {
                item.url = item.response ? item.response.url : '';
                item.path = item.response ? item.response.url : '';
                item.resourceId = item.uid;
                if (item.response) {
                    let ext = "";
                    if (item.response.storageFile && item.response.storageFile.name) {
                        ext = getSubffix(item.response.storageFile.name);
                    }
                    item.ext = ext;
                    item.preview = getFileImage(item.url, ext);
                    if (video.indexOf(item.ext) > -1) {
                        this.checkStatus(item.response.storageFile.md5, (stateStr) => {
                            // item.url = item.response ? item.response.url : '';
                            // item.path = item.response ? item.response.url : '';
                        }, (res) => {
                            this.setState({fileList: newFileList});
                        }, (stateStr) => {
                            if (item.uid === file.uid) {
                                item.stateStr = stateStr;
                            }
                        })
                    }
                }
                return item;
            });

            let accept;

            switch (this.props.resourceType) {
                case 1:
                    accept = "." + [...PIC_TYPE,].join(",.");
                    break;
                case 2:
                    accept = "." + [...AUDIO_TYPE].join(",.");
                    break;
                case 3:
                    accept = "." + [...VIDEO_TYPE].join(",.");
                    break;
                case 4:
                    accept = "." + [...FILE_TYPE].join(",.");
                    break;
                case 0:
                    accept = "." + [...FILE_TYPE].join(",.");
                    break;
            }
            let newSpliceFileList =newFileList;
                newSpliceFileList.forEach((item,index)=>{
                    let fileName = item.type.split('/')[1];
                    if(fileName==='quicktime'){
                        fileName = 'mov'
                    }
                    if(accept.indexOf(fileName) === -1){
                       newSpliceFileList.splice(item,1)
                    }
                });

                // this.props.updateFileList(newFileList);
               // return false
            this.setState({fileList: newSpliceFileList});
        }
        let accept;
        switch (this.props.resourceType) {
            case 1:
                accept = "." + [...PIC_TYPE,].join(",.");
                break;
            case 2:
                accept = "." + [...AUDIO_TYPE].join(",.");
                break;
            case 3:
                accept = "." + [...VIDEO_TYPE].join(",.");

                break;
            case 4:
                accept = "." + [...FILE_TYPE].join(",.");
                break;
            case 0:
                accept = "." + [...FILE_TYPE].join(",.");
                break;
        }

        let newSpliceFileList =  ArrayDuplication(fileList,'name')
        newSpliceFileList.forEach((item,index)=>{
            let newType='';
            let nameList=file.name.split('.');
            newType=nameList.length>0?nameList[nameList.length-1]:'';

            let fileName = item.type.split('/')[1];
            if(fileName==='quicktime'){
                fileName = 'mov'
            }
            if(accept.indexOf(fileName) === -1){
                if(accept.indexOf(newType) === -1) {
                    newSpliceFileList.splice(item,1)
                }

            }
        });
        this.setState({fileList:newSpliceFileList});

    };
    //检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatus(md5, ingCallBack, overCallBack,stateChangeCallBack=()=>{}){
        setTimeout(()=>{
            checkFileStatus(md5).then(res => {
                stateChangeCallBack(res.stateStr);
                if (res.state !== "mergeComplete") {
                    this.checkStatus(md5, ingCallBack, overCallBack,stateChangeCallBack);
                    ingCallBack(res.stateStr);
                } else {
                    overCallBack(res);
                }
            }).catch(() => {
                overCallBack({});
            });
        }, 300);//每隔一秒钟进行检查一次
    }
    //current 为0 的下一步
    oneNextStep = () => {

            let allPicList = [];
            let allVideoList = [];
            let allAudioList = [];
            let allFileList = [];
            this.state.fileList.forEach((item, index) => {
                if (PIC_TYPE.indexOf(item.ext) !== -1) {
                    allPicList.push(item);
                } else if (VIDEO_TYPE.indexOf(item.ext) !== -1) {
                    allVideoList.push(item);
                } else if (AUDIO_TYPE.indexOf(item.ext) !== -1) {
                    allAudioList.push(item);
                } else {
                    allFileList.push(item);
                }
            });

            let array = [];
            if (allPicList.length > 0) {
                array.push({name: "图片", list: allPicList});
            }
            if (allVideoList.length > 0) {
                array.push({name: "视频", list: allVideoList});
            }
            if (allAudioList.length > 0) {
                array.push({name: "音频", list: allAudioList});
            }
            if (allFileList.length > 0) {
                array.push({name: "文件", list: allFileList});
            }
            if (array.length === 0) {
                message.warn("请先上传文件");
                return;
            }
            allFile = [
                {name: "图片", list: allPicList},
                {name: "视频", list: allVideoList},
                {name: "音频", list: allAudioList},
                {name: "文件", list: allFileList}
    ];
            this.setState({current: 1, fileListClassify: array, publishFileListClassify: array});
        }


}
